import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postAddRoommatesToBasket } from 'src/api/basketService';
import { RoommateData } from 'src/features/multi-occupancy/types';
import { Basket } from 'src/store/slices/basket-slice';

export const usePostAddRoommatesToBasket = () =>
    useMutation<
        Basket,
        AxiosError,
        { basketId: string; roommates: RoommateData[]; updatedAt: string }
    >({
        mutationFn: ({ basketId, roommates, updatedAt }) =>
            postAddRoommatesToBasket(basketId, roommates, updatedAt),
    });
